var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "waf-component waf-breadcrumb widget-layout-03" },
    [
      _c("div", { staticClass: "layout-wrapper" }, [
        _c("nav", { attrs: { "aria-label": "breadcrumb" } }, [
          _c(
            "ol",
            {
              staticClass: "breadcrumb",
              attrs: {
                itemscope: "",
                itemtype: "https://schema.org/BreadcrumbList",
              },
            },
            _vm._l(_vm.getLevels(), function (b, idx) {
              return _c(
                "li",
                {
                  key: idx,
                  attrs: {
                    itemprop: "itemListElement",
                    itemscope: "",
                    itemtype: "https://schema.org/ListItem",
                  },
                },
                [
                  _c("a", { attrs: { itemprop: "item", href: b.link } }, [
                    _c("span", { attrs: { itemprop: "name" } }, [
                      _vm._v(_vm._s(b.name)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("meta", {
                    attrs: { itemprop: "position", content: idx + 1 },
                  }),
                ]
              )
            }),
            0
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }